<script>
    import {onMount} from 'svelte';

    import {Tooltip} from 'flowbite';

    import I18n from '@js/modules/translations';
    import AnalyticsService from '@js/modules/analyticsService';

    import Button from '@js/components/themes/Button.svelte';
    import Icon from '@js/components/themes/Icon.svelte';

    import shareIcon from '@js/components/icons/shareIcon';

    import RideShareModal from '@js/components/ride/share/RideShareModal.svelte';
    import ShareButtons from '@js/components/ride/share/ShareButtons.svelte';

    const RideSharePrivate = () => import('@js/components/ride/share/RideSharePrivate.svelte');

    const {
        rideId,
        rideName,
        rideUrl,
        rideVisibility,
        rideSharedUrl
    } = $props();

    let isShowModal = $state(false);

    const _handleShowModal = () => {
        isShowModal = true;

        AnalyticsService.trackShareRideModalShow('Ride show');
    };

    onMount(() => {
        const rideTooltipElement = document.getElementById('tooltip-share-ride');
        const rideTooltipTrigger = document.getElementById('share-ride');
        new Tooltip(rideTooltipElement, rideTooltipTrigger, {
            placement: 'top',
            triggerType: 'hover'
        });
    });
</script>

<RideShareModal bind:isModalOpen={isShowModal}>
    {#if rideVisibility === 'only_me' && !rideSharedUrl}
        {#await RideSharePrivate() then RideSharePrivateLoader}
            {@const
                RideSharePrivateComponent = RideSharePrivateLoader.default}
            <RideSharePrivateComponent rideId={rideId}/>
        {/await}
    {:else}
        <ShareButtons sharedUrl={rideSharedUrl || rideUrl}
                      sharedName={rideName}/>
    {/if}
</RideShareModal>

<Button id="share-ride"
        class="block"
        color="primary-light"
        rounded={true}
        onClick={_handleShowModal}
        data-tooltip-target="tooltip-share-ride">
    <Icon class="w-5 h-5"
          icon={shareIcon}/>
</Button>

<div id="tooltip-share-ride"
     role="tooltip"
     class="absolute inline-block px-3 py-2 invisible text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-xs opacity-0 z-10 tooltip">
    {I18n.t('js.ride.map.share_ride')}
    <div class="tooltip-arrow" data-popper-arrow></div>
</div>
